import { LoanDetails } from '../data/types/loanDetails'

export function getClosestLoan(loans: LoanDetails[]): LoanDetails {
  const today = new Date()
  if (loans.length === 0) {
    throw new Error('No loans available to find the closest loan.')
  }
  const closestLoan = loans.reduce((closest, loan) => {
    const loanDate = new Date(loan.plannedOnDateUTC)
    const diff = Math.abs(loanDate.getTime() - today.getTime())
    return diff < Math.abs(new Date(closest.plannedOnDateUTC).getTime() - today.getTime()) ? loan : closest
  }, loans[0])

  return closestLoan
}
